import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconMoon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.3603 3.06624C10.545 3.32685 10.5444 3.67587 10.3588 3.93584C9.54573 5.07441 9.06752 6.46746 9.06752 7.97442C9.06752 11.8172 12.1827 14.9325 16.0256 14.9325C17.5325 14.9325 18.9256 14.4543 20.0641 13.6412C20.3241 13.4556 20.6731 13.455 20.9337 13.6397C21.1943 13.8245 21.3093 14.154 21.2202 14.4608C20.0812 18.3824 16.4622 21.25 12.1715 21.25C6.96817 21.25 2.75 17.0318 2.75 11.8284C2.75 7.53776 5.61757 3.91878 9.53923 2.77975C9.84599 2.69065 10.1755 2.80564 10.3603 3.06624ZM8.09192 5.03657C5.78955 6.42258 4.25 8.94635 4.25 11.8284C4.25 16.2034 7.7966 19.75 12.1715 19.75C15.0536 19.75 17.5774 18.2104 18.9634 15.9081C18.048 16.2472 17.0581 16.4325 16.0256 16.4325C11.3543 16.4325 7.56752 12.6457 7.56752 7.97442C7.56752 6.94192 7.75281 5.95198 8.09192 5.03657Z",
		fill: "currentColor"
	})
});
export { SvgIconMoon as ReactComponent };
